const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

const isValidInteger = (value) => Number.isInteger(value);

const getTextLength = (text) =>
  typeof text === "string" ? text.length : String(text ?? "").length;

export const normalizeTextareaSelection = (selection, textLength) => {
  const safeTextLength =
    isValidInteger(textLength) && textLength >= 0 ? textLength : 0;

  if (
    !selection ||
    !isValidInteger(selection.start) ||
    !isValidInteger(selection.end)
  ) {
    return { start: safeTextLength, end: safeTextLength };
  }

  const start = clamp(selection.start, 0, safeTextLength);
  const end = clamp(selection.end, 0, safeTextLength);

  if (start <= end) {
    return { start, end };
  }

  return { start: end, end: start };
};

export const getTextareaSelection = (textarea, fallbackText = "") => {
  const safeTextLength = getTextLength(textarea?.value ?? fallbackText);

  return normalizeTextareaSelection(
    {
      start: textarea?.selectionStart,
      end: textarea?.selectionEnd,
    },
    safeTextLength,
  );
};

export const shouldClearForcedSelection = (forcedSelection, nextSelection) =>
  Boolean(
    forcedSelection &&
      nextSelection &&
      forcedSelection.start === nextSelection.start &&
      forcedSelection.end === nextSelection.end,
  );

export const applyForcedSelectionToTextarea = (textarea, selection) => {
  if (!textarea || typeof textarea.setSelectionRange !== "function") {
    return false;
  }

  const normalizedSelection = normalizeTextareaSelection(
    selection,
    getTextLength(textarea?.value ?? ""),
  );

  textarea.setSelectionRange(
    normalizedSelection.start,
    normalizedSelection.end,
  );
  return true;
};

export default getTextareaSelection;
